import { Info } from 'lucide-react';
import { Inline } from '../../../../design-system/inline/inline';

export const OpenBankingAccountDisclaimer = () => {
  return (
    <Inline space={1.5} wrap="nowrap" align="start" className="px-3 py-1.5">
      <div className="mt-1 h-3 w-3 text-muted-foreground">
        <Info className="h-full w-full" aria-hidden="true" />
      </div>

      <p className="text-xs leading-5 tracking-tight text-muted-foreground">
        We'll only sync invoices paid using this account.
      </p>
    </Inline>
  );
};
